import { Block, BlockFooter, Link, LoginScreenTitle, Page } from "framework7-react";

import { SignUpForm } from "@/components/SignUpForm";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { usePageReady } from "@/hooks/usePageReady";

export const AuthSignUpPage = createPage("AuthSignUpPage", PageComponent);

function PageComponent({ pageName }: PageComponentProps) {
  const { getPageProps } = usePageReady(pageName);

  return (
    <Page
      loginScreen
      noNavbar
      noSwipeback
      noToolbar
      data-component={pageName}
      {...getPageProps()}
    >
      <LoginScreenTitle>アカウント登録</LoginScreenTitle>
      <SignUpForm />
      <Block>
        <BlockFooter>
          アカウントをお持ちの場合 &nbsp;
          <Link href="/sign-in/">ログインはこちら</Link>
        </BlockFooter>
        <BlockFooter>
          パスワードを忘れた場合 &nbsp;
          <Link href="/password-reset/">再登録はこちら</Link>
        </BlockFooter>
      </Block>
    </Page>
  );
}
